import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Screener from "./pages/Screener";
import CompanyDetail from "./pages/CompanyDetail";
import DependsOn from "./pages/DependsOn";
import Accuracy from "./pages/Accuracy";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import Sitemap from "./pages/Sitemap";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import { trackEvent } from "./lib/analytics";

function AppRouter() {
  const location = useLocation();
  // Fire a page_view on every SPA route change so GA4 + PostHog track navigation.
  useEffect(() => {
    trackEvent("page_view", {
      path: location.pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname]);
  // Synchronous check (NOT useEffect): process a fresh session_id before any route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/screener" element={<Screener />} />
      <Route path="/who-buys" element={<DependsOn />} />
      <Route path="/accuracy" element={<Accuracy />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/sitemap" element={<Sitemap />} />
      <Route path="/company/:ticker" element={<CompanyDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback/:provider" element={<AuthCallback />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
